const RenderHTML = () => {
    return <>
        <div className="alert alert-info">HERE GOES HTML</div>
    </>
}

export default RenderHTML;